import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import { Services } from './pages/Services';
import { ServiceDetail } from './pages/Services';
import { Portfolio, PortfolioDetail } from './pages/Portfolio';
import { Blog, BlogDetail } from './pages/Blog';
import { GetQuote } from './pages/GetQuote';
import { Contact } from './pages/Contact';
import { About } from './pages/About';
import { Profile } from './pages/Profile';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Pages that don't show the regular footer
const NO_FOOTER = ['/login', '/register'];

export default function App() {
  const { pathname } = useLocation();
  const showFooter = !NO_FOOTER.includes(pathname);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/"                  element={<Home />} />
          <Route path="/login"             element={<Login />} />
          <Route path="/register"          element={<Register />} />
          <Route path="/services"          element={<Services />} />
          <Route path="/services/:id"      element={<ServiceDetail />} />
          <Route path="/portfolio"         element={<Portfolio />} />
          <Route path="/portfolio/:id"     element={<PortfolioDetail />} />
          <Route path="/blog"              element={<Blog />} />
          <Route path="/blog/:id"          element={<BlogDetail />} />
          <Route path="/get-quote"         element={<GetQuote />} />
          <Route path="/contact"           element={<Contact />} />
          <Route path="/about"             element={<About />} />
          <Route path="/dashboard"         element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/profile"           element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/admin"             element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
          <Route path="*"                  element={<NotFound />} />
        </Routes>
      </main>
      {showFooter && <Footer />}
    </>
  );
}

function NotFound() {
  return (
    <div style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '40px 24px' }}>
      <div style={{ fontSize: 64, marginBottom: 20 }}>404</div>
      <h1 style={{ fontFamily: 'Inter', fontSize: 28, fontWeight: 900, color: '#1a1a17', marginBottom: 12 }}>Page not found</h1>
      <p style={{ color: '#6b6b63', marginBottom: 28 }}>The page you're looking for doesn't exist or has been moved.</p>
      <a href="/" style={{ background: 'linear-gradient(135deg,#9747FF,#E040FB)', color: '#fff', padding: '13px 28px', borderRadius: 8, fontWeight: 700, fontSize: 14 }}>← Go home</a>
    </div>
  );
}
